import React, {useEffect} from 'react';
import {Box, IconButton, Stack, Typography} from '@mui/material';
import {Outlet, useNavigate, useParams} from 'react-router-dom';

import {SupplierUnitDetailsRoutes} from '@utils/routes.utils';

import {ArrowBack} from '@icons/index';

import RoutesTabsComponent from '@components/tabs/RoutesTabs.component';
import {useObservable} from '@ngneat/react-rxjs';
import {suppliersUnitsDetailsQuery, supplierUnitsDetailsService} from '@store/suppliers/units/details';

const SupplierUnitDetailsScreen = () => {
  const navigate = useNavigate();
  const {supplierUnitId} = useParams();

  const [{headOffice}] = useObservable(suppliersUnitsDetailsQuery.supplierUnitDetails$);

  useEffect(() => {
    if (supplierUnitId) {
      supplierUnitsDetailsService.getSupplierUnitById(supplierUnitId).subscribe();
    }

    return () => {
      supplierUnitsDetailsService.resetStore();
    };
  }, [supplierUnitId]);

  if (!headOffice.name) return null;

  const handleClose = () => {
    navigate('..');
  };

  return (
    <Stack flex={1} width="100%" pt="34px" px="24px" spacing={3} overflow="hidden">
      <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1} ml="-9px">
        <IconButton onClick={handleClose}>
          <ArrowBack/>
        </IconButton>
        <Typography fontSize="30px" fontWeight="700">
          {headOffice?.name}
        </Typography>
      </Stack>
      <Stack flex={1} overflow="hidden">
        <Box>
          <RoutesTabsComponent routes={SupplierUnitDetailsRoutes.routes()}/>
        </Box>
        <Outlet/>
      </Stack>
    </Stack>
  );
};

export default SupplierUnitDetailsScreen;
